{
  "version": 1,
  "asset_id": "5939473c-43f4-4982-9962-1f2c3a095a7d",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/5939473c-43f4-4982-9962-1f2c3a095a7d/rudolph-th-logo.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/5939473c-43f4-4982-9962-1f2c3a095a7d/rudolph-th-logo.png",
  "original_filename": "rudolph-th-logo.png",
  "size": 178017,
  "content_type": "image/png",
  "created_at": "2026-08-26T12:40:10Z"
}
